import { render, staticRenderFns } from "./details.vue?vue&type=template&id=5fd5358c&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=5fd5358c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd5358c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd5358c')) {
      api.createRecord('5fd5358c', component.options)
    } else {
      api.reload('5fd5358c', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=5fd5358c&scoped=true&", function () {
      api.rerender('5fd5358c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/popups/profil/details.vue"
export default component.exports